// extracted by mini-css-extract-plugin
module.exports = {"title":"title__2-3zh","image":"image__3EKz5","content":"content__2Pfsx","contacts":"contacts__4gU2B","contact":"contact__3pu9d","map":"map__3mn8P","margin":"margin__lc-kR"};